<template>
    <div class="wrapper">
        <Navbar></Navbar>
        <Sidebar></Sidebar>
        <div id="content-wrap" class="content-wrapper">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    import 'admin-lte'

    import Navbar from "../../template/Navbar";
    import Sidebar from "../../template/AdminSidebar";

    export default {
        components: {
            Navbar,
            Sidebar
        },
        mounted() {
            $('body').layout('fix');
        },
    }
</script>
